import React from "react";
import Calendar from "../../assets/icons/Calendar.svg";
import styles from "./Datepicker.module.css";

const Datepicker = ({ date, onChange, label = "As on date" }) => {
  return (
    <div className={styles.dateRange}>
      <div className={styles.datePicker}>
        <span className={styles.label}>{label}</span>
        <input
          type="date"
          className={styles.input}
          value={date}
          onChange={onChange}
        />
        <img src={Calendar} alt="calendar" className={styles.icon} />
      </div>
    </div>
  );
};

export default Datepicker;
